import styled from 'styled-components/native'

export const LabelContainer = styled.View({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  width: '100%',
})
